export default {
    intervalBetweenKeyPress: 100,
    scanningEndTimeout: 200,  
    debug: true,
    ignoreOnInputs: true,
    historyLength: 5,
  }